import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-approve",
  "use": "icon-approve-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 22 22\" id=\"icon-approve\"><g><path d=\"M11,0C17.0753,0,22,4.9247,22,11C22,17.0753,17.0753,22,11,22C4.9247,22,0,17.0753,0,11C0,4.9247,4.9247,0,11,0ZM11,4.4C10.3925,4.4,9.9,4.89249,9.9,5.5L9.9,11C9.90006,11.2917,10.016,11.5715,10.2223,11.7777L13.5223,15.0777C13.9539,15.4946,14.64,15.4886,15.0643,15.0643C15.4886,14.64,15.4946,13.9539,15.0777,13.5223L12.1,10.5446L12.1,5.5C12.1,4.89249,11.6075,4.4,11,4.4Z\" fill=\"#E354D4\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/approve.svg
// module id = VHlD
// module chunks = 119